const state = {
    //state中的数据默认初始值不要乱写
    currentActiveIndex: 0
};
const mutations = {
    SETACTIVEINDEX(state, index) {
        state.currentActiveIndex = index;
    },
};
const actions = {
    //判断是否为微信客户端
    setActiveIndex({commit}, index) {
        commit('SETACTIVEINDEX', index);
    },
};
const getters = {};

export default {
    state,
    mutations,
    actions,
    getters
}
